// extracted by mini-css-extract-plugin
module.exports = {"container":"svg_container__GQ72p","gradient":"svg_gradient__3fhZ0"};